import fileDownload from 'react-file-download';
import { shopPrefix } from '../../../config';
import { format } from 'date-fns';
import { http } from '../../axios';

const endpointPdfDownload = `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/pdf`;
export function downloadAnalyticsPdf(campaignProductId: string) {
    return http
        .get(endpointPdfDownload, {
            responseType: 'arraybuffer',
            pathParams: { campaignProductId },
            headers: {
                Accept: 'application/pdf'
            }
        })
        .then(response => {
            const now = format(new Date(), 'yyyy-MM-dd');
            fileDownload(response.data, `CampaignReport_${campaignProductId}_${now}.pdf`);
        });
}
